const SET_CHANNEL_TO_PROVIDER_LIST = '@channel-to-provider/set-channel-to-provider-list';
const SET_CHANNEL_TO_PROVIDER_DETAIL = '@channel-to-provider/set-channel-to-provider-detail';

export {SET_CHANNEL_TO_PROVIDER_LIST, SET_CHANNEL_TO_PROVIDER_DETAIL};